import { render, staticRenderFns } from "./ReturnVisit.vue?vue&type=template&id=06cc5584&scoped=true"
import script from "./ReturnVisit.vue?vue&type=script&lang=js"
export * from "./ReturnVisit.vue?vue&type=script&lang=js"
import style0 from "./ReturnVisit.vue?vue&type=style&index=0&id=06cc5584&prod&lang=scss&scoped=true"
import style1 from "./ReturnVisit.vue?vue&type=style&index=1&id=06cc5584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc5584",
  null
  
)

export default component.exports